import { createPortal } from 'react-dom';

/**
 * Renders children into document.body so fixed overlays escape
 * header transforms / backdrop-filter stacking contexts.
 */
const Portal = ({ children }) => {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
};

export default Portal;
